<template>
  <div class="equipmentContainer">
    <img class="banner" src="@/assets/image/equipment/banner.png" alt="" />
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip1.png" alt="" />
      <div class="equipName">部标一体机汽车“黑匣子”</div>
      <div class="eqipfun">
        <div class="title">WY-部标</div>
        <div class="desc">满足交通部部标要求及3C所有功能</div>
      </div>
    </div>
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip2.png" alt="" />
      <div class="equipName">4G车载视频全方位监控</div>
      <div class="eqipfun">
        <div class="title">WY-记录仪</div>
        <div class="desc">前后高清双摄，让行驶更安心</div>
      </div>
    </div>
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip3.png" alt="" />
      <div class="equipName">主动安全部标一体机</div>
      <div class="eqipfun">
        <div class="title">WY-820</div>
        <div class="desc">主动安全设备高级辅助驾驶</div>
      </div>
    </div>
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip4.png" alt="" />
      <div class="equipName">伪基站、探测仪的杀手锏</div>
      <div class="eqipfun">
        <div class="title">WY-MINIS</div>
        <div class="desc">精致小巧，便于隐匿车身，多种模式让定位更精准</div>
      </div>
    </div>
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip5.png" alt="" />
      <div class="equipName">分米级高精度定位</div>
      <div class="eqipfun">
        <div class="title">WY-05</div>
        <div class="desc">分米级定位，精准把握资产状态</div>
      </div>
    </div>
    <div class="eqipItem">
      <img src="@/assets/image/equipment/eqip6.png" alt="" />
      <div class="equipName">智能诊断系统</div>
      <div class="eqipfun">
        <div class="title">WY-OTRACK</div>
        <div class="desc">实时定位、VIN码读取、车况诊断，全面把握行车安全</div>
      </div>
    </div>
    <div class="eqipItem lastItem">
      <img src="@/assets/image/equipment/eqip7.png" alt="" />
      <div class="equipName">精准无损油量监测专家</div>
      <div class="eqipfun">
        <div class="title">WY-超声波</div>
        <div class="desc">无须打孔，还可循环使用</div>
      </div>
    </div>
    <div class="eqipItem lastItem">
      <img src="@/assets/image/equipment/eqip8.png" alt="" />
      <div class="equipName">进口芯片、高低温信号转换器</div>
      <div class="eqipfun">
        <div class="title">WY-温度控制</div>
        <div class="desc">防水防潮防生锈，抗干扰</div>
      </div>
    </div>
    <div class="tel" @click="callPhone"></div>
  </div>
</template>

<script>
  export default {
    methods: {
      callPhone() {
        window.android.call("0571-86553502")
      }
    },
  }
</script>

<style lang="scss" scoped>
  .equipmentContainer {
    .banner {
      height: 300px;
      margin-bottom: 34px;
    }
    .eqipItem {
      height: 312.5px;
      width: 192px;
      margin-bottom: 10px;
      margin-left: 10px;
      float: left;
      font-size: 0;
      border-radius: 12px 12px 0 0;
      img {
        width: 192px;
        height: 191.5px;
      }
      .equipName {
        padding-left: 8px;
        height: 31px;
        line-height: 31px;
        font-size: 13.5px;
        color: #938569;
        background: #efece3;
      }
      .eqipfun {
        height: 90px;
        box-sizing: border-box;
        padding-left: 9px;
        padding-right: 12px;
        border: 1px solid #dde3ec;
        background: #ffffff;
        .title {
          height: 40px;
          margin-bottom: 7px;
          line-height: 40px;
          font-size: 18px;
          font-weight: bold;
          color: #00b38a;
          border-bottom: 1px solid rgba(221, 227, 236, 0.6);
        }
        .desc {
          font-size: 12px;
          color: #777e88;
        }
      }
    }
    .lastItem {
      margin-bottom: 60px;
    }
    .tel {
      width: 100%;
      height: 53px;
      position: fixed;
      bottom: 0;
      background-image: url("~@/assets/image/equipment/tel.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      a {
        display: block;
        height: 100%;
      }
    }
  }
</style>